import { ISelectOption } from 'UIPackage/MainModule/components/SelectInput';

export const agreementStatusOptions: ISelectOption<string>[] = [
  {
    id: 'DRAFT',
    label: 'Черновик',
    value: 'DRAFT',
  },
  {
    id: 'READY_TO_APPROVE',
    label: 'Готово к согласованию',
    value: 'READY_TO_APPROVE',
  },
  {
    id: 'CANCELED',
    label: 'Отказано',
    value: 'CANCELED',
  },
  {
    id: 'ON_APPROVAL',
    label: 'На согласовании',
    value: 'ON_APPROVAL',
  },
  {
    id: 'DENIED',
    label: 'Не согласовано',
    value: 'DENIED',
  },
  {
    id: 'APPROVED',
    label: 'Утверждено',
    value: 'APPROVED',
  },
  {
    id: 'TERMINATED',
    label: 'Расторгнуто',
    value: 'TERMINATED',
  },
  {
    id: 'COMPLETED',
    label: 'Исполнено',
    value: 'COMPLETED',
  },
  {
    id: 'NOT_COMPLETED',
    label: 'Не исполнено',
    value: 'NOT_COMPLETED',
  },
  {
    id: 'PENDING_TERMINATION',
    label: 'Не исполнено. Ожидает расторжения',
    value: 'PENDING_TERMINATION',
  },
];
